/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: Owner = 1, Member = 2
 */
export enum Routemize_Constants_PartnerUserRole {
    OWNER = 'Owner',
    MEMBER = 'Member',
}
